import { Component, OnInit } from '@angular/core';
import { FinanceService } from '../shared/finance.service';
import 'rxjs/add/operator/toPromise';
import { formatDate } from '@telerik/kendo-intl';
import { AxisLabelsPosition } from '@progress/kendo-angular-charts';

@Component({
  selector: 'app-finance-dashboard',
  templateUrl: './finance-dashboard.component.html',
  styleUrls: ['./finance-dashboard.component.scss']
})
export class FinanceDashboardComponent implements OnInit {

  salesList: any[];
  //totalSalesProfit: any[];
  currentDate = new Date();
  formattedDate = formatDate(this.currentDate, "dd/MM/yyyy");
  splitedDate = this.formattedDate.split('/');
  splitedMonth = this.splitedDate[1];
  currentMonthKey: any;
  splitDate: any;
  currentMonth: any;
  monthSales: any;
  totalSales = 0;
  profitArray: any;
  lossArray: any;
  EmployeeSalaryList: any[];
  totalSalary=0;
  totalLoss: any;
  totalLossOriginal: any;
  totalProfit: any;
  totalProfitOriginal: any;
  overallTotalProfit = 0;
  overallTotalLoss = 0;
  netProfit: any;
  amount: number;
  TransactionsList: any[];
  monthLoss = 0;
  monthProfit = 0;
  vat: any;
  salesCount: any;
  salesCountOriginal: any;
  computedSalesCount: any;
  computedLowestSalesCount: any;
  computedProfitableMonth: any[];
  computedLeastProfitableMonth: any[];
  YTDExpense: any;
  mostYTDExpense: any;
  expenseByCategory: any;
  lossArrayList: any[];
  payroll=0;
  quarters: string[][];
  quarterProfit: any;
  quarterLoss: any;
  salesName: string;
  quarterIndex: string[];
  
    
  constructor(private financeService: FinanceService) { 
    this.pieData = [];
    this.pieDataOriginal = [];
  }

  ngOnInit() {
    this.getAllTransactions();
    this.getAllEmployeeSalary();
    this.getSalesList();
    this.getVat();
  }


  // public pieData: any = [
  //   { category: 'Fuel', value: 20 },
  //   { category: 'Fleet', value: 28 },
  //   { category: 'Salary', value: 22 },
  //   { category: 'Insurance', value: 40 }
  // ]

   pieData: any[];
   pieDataOriginal:any[];
   public categoryLabelsPosition: AxisLabelsPosition = 'start';

  getMonth(j) {
    var month;
    switch (String(j)) {
      case "0": month = "January";
        break;
      case "1": month = "February";
        break;
      case "2": month = "March";
        break;
      case "3": month = "April";
        break;
      case "4": month = "May";
        break;
      case "5": month = "June";
        break;
      case "6": month = "July";
        break;
      case "7": month = "August";
        break;
      case "8": month = "September";
        break;
      case "9": month = "October";
        break;
      case "10": month = "November";
        break;
      case "11": month = "December";
        break;
    }
    return month;
  }
  getSalesList() {
    var self = this;
    var splitDate = String(this.formattedDate).split('/');
    self.currentMonth = splitDate[1];
    self.currentMonthKey = self.currentMonth - 1;
    this.financeService.getSalesList().then(res => {
      self.salesList = [];
      self.salesCount = [];
      self.salesCountOriginal = [];
      self.computedSalesCount = [];
      self.computedLowestSalesCount = [];
      for (var i = 0; i <= 11; i++) {
        self.salesList[String(i)] = 0;
        self.salesCount[String(i)] = 0;
        self.salesCountOriginal[String(i)] = 0;
      }
      res.forEach(function (childSnap) {

        var date = childSnap.child("createdAt").val();
        var splitDate = date.split('/');
        var month = splitDate[1];
        if (childSnap.child("total").val()) {
          var key = month - 1;
          self.salesList[String(key)] = self.salesList[String(key)] + parseInt(childSnap.child("total").val());
        }
        if (childSnap.child("createdAt").val()) {
          // var date = childSnap.child("createdAt").val();
          // var splitDate = date.split('/');
          // var month = splitDate[1];
          var monthKey = month - 1;
          if (monthKey === self.currentMonthKey) {
            self.totalSales = self.totalSales + 1;
          }
          self.salesCountOriginal[String(monthKey)] = self.salesCountOriginal[String(monthKey)] + 1;
          self.salesCount[String(monthKey)] = self.salesCount[String(monthKey)] + 1;

        }
      });
      this.getArray(self.salesCountOriginal,'salesCount');

      //Three Largest & Lowest Sales

      self.salesCount.sort(function (a, b) {
        if (a < b) { return 1; }
        else if (a == b) { return 0; }
        else { return -1; }
      });
      for (i = 0; i < 3; i++) {
        for (var j = 0; j < 12; j++) {
          if (self.salesCount[String(i)] === self.salesCountOriginal[String(j)] && self.computedSalesCount.length < 3) {
            var month = this.getMonth(j);
            self.computedSalesCount.push({ "month": month, "sales": self.salesCount[String(i)] });
          }
        }
      }
      //console.log("highest==> " + self.computedSalesCount);

      self.salesCount.sort(function (a, b) {
        if (a > b) { return 1; }
        else if (a == b) { return 0; }
        else { return -1; }
      });
      for (i = 0; i < 3; i++) {
        for (var j = 0; j < 12; j++) {
          if (self.salesCount[String(i)] === self.salesCountOriginal[String(j)] && self.computedLowestSalesCount.length < 3) {
            var month = this.getMonth(j);
            self.computedLowestSalesCount.push({ "month": month, "sales": self.salesCount[String(i)] });
          }
        }
      }

      //Three Largest & Lowest Sales End

      var salesKey = self.currentMonth - 1;
      self.monthSales = self.salesList[String(salesKey)];
      // for (var i = 0; i <= 11; i++) {
      //   self.totalSalesProfit = self.totalSalesProfit + self.salesList[i];
      // }
      //console.log(self.salesList);
    });
  }

  getAllTransactions() {
    var self = this;
    var groups = {};
    this.profitArray = [];
    this.lossArray = [];
    this.amount = 0;
    this.financeService.getAllTransactionListByYear().then(res => {
      self.TransactionsList = [];
      self.YTDExpense = [];
      self.mostYTDExpense = [];
      res.forEach(function (childSnap) {
        var groupName = String(childSnap.child("categoryName").val());
        if (!groups[groupName]) {
          groups[groupName] = [];
        }
        groups[groupName].push({
          "Date": String(childSnap.child("date").val()),
          "Description": String(childSnap.child("description").val()),
          "Amount": String(childSnap.child("amount").val()),
          "id": childSnap.key
        });
      });

      for (var groupName in groups) {
        groups[groupName].push({ "monthlyAmount": { "01": 0, "02": 0, "03": 0, "04": 0, "05": 0, "06": 0, "07": 0, "08": 0, "09": 0, "10": 0, "11": 0, "12": 0 } }, { "finalRowAmount": 0 });
      }

      for (var groupName in groups) {
        var length = groups[groupName].length;
        for (var index in groups[groupName]) {
          if (index < String(groups[groupName].length - 2)) { // -1 ... -1
            var date = groups[groupName][index].Date.split("/");
            var month = String(date[1]);
            groups[groupName][length - 2].monthlyAmount[month] = groups[groupName][length - 2].monthlyAmount[month] + parseInt(groups[groupName][index].Amount); // -1
            groups[groupName][length - 1].finalRowAmount = groups[groupName][length - 1].finalRowAmount + parseInt(groups[groupName][index].Amount); // not there
          }

        }
        if (groups[groupName][0].Amount.indexOf('-') > -1) {
          self.YTDExpense.push([groups[groupName][(groups[groupName]).length - 1].finalRowAmount]);
        }

        if (groups[groupName][0].Amount.indexOf('-') <= -1) {
          self.profitArray.push({ groupName: groupName, group: groups[groupName] });
        } else {
          self.lossArray.push({ groupName: groupName, group: groups[groupName] });
        }
      }
      self.getArray(self.lossArray,'lossArray');
      // console.log("self.profitArray");
      // console.log(self.YTDExpense);
      // console.log(self.profitArray);
      // console.log(self.lossArray);
      // console.log("self.profitArrayEnd");
      self.YTDExpense.sort(function (a, b) {
        if (a < b) { return 1; }
        else if (a == b) { return 0; }
        else { return -1; }
      });

      for (var j = 0; j < self.YTDExpense.length; j++) {
        for (var i = 0; i < self.lossArray.length; i++) {
          var key = self.lossArray[i].group["length"] - 1;
          if(self.lossArray[i].group[key].finalRowAmount === self.YTDExpense[j][0]) {
            if(self.mostYTDExpense.length < 3) {
              self.mostYTDExpense.push({ "Category": self.lossArray[i].groupName, "Amount": self.YTDExpense[j][0] });
            }
            //self.expenseByCategory.push({ "Category": self.lossArray[i].groupName, "Amount": self.YTDExpense[j][0] });
          }
        }
      }

      // console.log("self.profitArray");
      // console.log(self.YTDExpense);
      // console.log(self.profitArray);
      // console.log(self.lossArray);
      // console.log("self.profitArrayEnd");
      // for (var i = 0; i < 3; i++) {
      //   for (var j = 0; j < 12; j++) {
      //     if (this.totalLoss[String(j)] === this.totalProfitOriginal[String(i)] && this.computedLeastProfitableMonth.length < 3) {
      //       month = this.getMonth(j);
      //       this.computedLeastProfitableMonth.push({ "month": month, "profit": this.totalLoss[String(j)] });
      //     }
      //   }
      // }

    });
  }

  getAllEmployeeSalary() {
    var self = this;
    this.financeService.getAllEmployeeSalary().then(res => {
      self.EmployeeSalaryList = [];
      for (var i = 0; i <= 11; i++) {
        self.EmployeeSalaryList[String(i)] = 0;
      }
      res.forEach(function (childSnap) {
        var key = childSnap.key - 1;
        childSnap.forEach(function (child) {
          self.EmployeeSalaryList[String(key)] = self.EmployeeSalaryList[String(key)] - parseInt(child.child("computedSalary").val());
        });
      });
      for (var i = 0; i <= 11; i++) {
        self.totalSalary = self.totalSalary + self.EmployeeSalaryList[i];
      }
      //console.log(self.EmployeeSalaryList);
      this.calculateLossAndProfit();
      this.getArray(self.totalSalary,'totalSalary')
    });
  }

  calculateLossAndProfit() {
    var self = this;
    var splitDatePL = String(this.formattedDate).split('/');
    self.currentMonth = splitDatePL[1];
    self.currentMonthKey = self.currentMonth - 1;
    this.totalProfit = [];
    this.totalLoss = [];
    this.netProfit = [];
    this.totalProfitOriginal = [];
    this.totalLossOriginal = [];
    this.computedProfitableMonth = [];
    this.computedLeastProfitableMonth = [];

    for (var x = 0; x <= 11; x++) {
      this.totalProfit[String(x)] = 0.0;
      this.totalLoss[String(x)] = 0.0;
      this.totalProfitOriginal[String(x)] = 0.0;
      this.totalLossOriginal[String(x)] = 0.0;
    }
    //Profit
    for (var i = 0; i < this.profitArray.length; i++) {
      for (var j = 0; j < this.profitArray[i].group.length; j++) {
        if (this.profitArray[i].group[j].Date) {
          var splitDate = this.profitArray[i].group[j].Date.split('/');
          var month = splitDate[1] - 1;
          this.totalProfit[String(month)] = parseFloat(this.totalProfit[String(month)]) + parseFloat(this.profitArray[i].group[j].Amount);
        }
      }
    }

    //Loss
    for (var i = 0; i < this.lossArray.length; i++) {
      for (var j = 0; j < this.lossArray[i].group.length; j++) {
        if (this.lossArray[i].group[j].Date) {
          var splitDate = this.lossArray[i].group[j].Date.split('/');
          var month = splitDate[1] - 1;
          this.totalLoss[String(month)] = this.totalLoss[String(month)] + parseFloat(this.lossArray[i].group[j].Amount);
        }
      }
    }

    //ADD SALES TO PROFIT AND PAYROLL TO LOSS
    for (var i = 0; i < this.salesList.length; i++) {
      this.totalProfit[String(i)] = parseFloat(this.totalProfit[String(i)]) + parseFloat(this.salesList[i]);
      this.totalProfitOriginal[String(i)] = parseFloat(this.totalProfitOriginal[String(i)]) + parseFloat(this.totalProfit[String(i)]);
      this.overallTotalProfit = this.overallTotalProfit + this.totalProfit[String(i)];
      this.totalLoss[String(i)] = parseFloat(this.totalLoss[String(i)]) + parseFloat(this.EmployeeSalaryList[i]);
      this.totalLossOriginal[String(i)] = parseFloat(this.totalLossOriginal[String(i)]) + this.totalLoss[String(i)];
      this.overallTotalLoss = this.overallTotalLoss + this.totalLoss[String(i)];

      //Net Profit
      this.netProfit[String(i)] = this.totalProfit[String(i)] + this.totalLoss[String(i)];
    }

    //Three Largest & Lowest Profits

    this.totalProfitOriginal.sort(function (a, b) {
      if (a < b) { return 1; }
      else if (a == b) { return 0; }
      else { return -1; }
    });
    for (i = 0; i < 3; i++) {
      for (var j = 0; j < 12; j++) {
        if (this.totalProfit[String(j)] === this.totalProfitOriginal[String(i)] && this.computedProfitableMonth.length < 3) {
          month = this.getMonth(j);
          this.computedProfitableMonth.push({ "month": month, "profit": this.totalProfit[String(j)] });
        }
      }
    }
    //console.log("highest==> " + self.computedSalesCount);

    this.totalProfitOriginal.sort(function (a, b) {
      if (a > b) { return 1; }
      else if (a == b) { return 0; }
      else { return -1; }
    });
    for (i = 0; i < 3; i++) {
      for (var j = 0; j < 12; j++) {
        if (this.totalLoss[String(j)] === this.totalProfitOriginal[String(i)] && this.computedLeastProfitableMonth.length < 3) {
          month = this.getMonth(j);
          this.computedLeastProfitableMonth.push({ "month": month, "profit": this.totalLoss[String(j)] });
        }
      }
    }

    //Three Largest & Lowest Profits End

    //Month Profit and Month Loss
    for (var x = 0; x <= 11; x++) {
      if (x === this.currentMonthKey) {
        this.monthProfit = this.monthProfit + this.totalProfit[String(x)];
        this.monthLoss = this.monthLoss + this.totalLoss[String(x)];
      }
    }

    //console.log("totalProfit==> " + this.overallTotalProfit);
    //console.log("totalLoss==> " + this.totalLoss);
  }

  getVat() {
    var x = this.financeService.getVat();
    this.vat = 0;
    x.snapshotChanges().subscribe(item => {
      item.forEach(element => {
        this.vat = (element.payload.child("vatAmount").val() / 100);
        //console.log("vat" + this.vat);
      });
    });
  }

  // getLossArray(array) {
  //   this.lossArrayList = array; 
  //   this.getExpenseByCategory(this.splitedMonth);
  //   var el =  (<HTMLInputElement>document.getElementById("ExpenseByCategoryMonth"));
  //   el.value = this.splitedMonth;
  // }

  getExpenseByCategory(month,payroll) {
    this.pieDataOriginal = [];
    for(var x=0; x<this.lossArrayList.length;x++) {
      for(var y=0;y<this.lossArrayList[x].group.length;y++) {
        if(this.lossArrayList[x].group[y].Date) {
        var date = this.lossArrayList[x].group[y].Date;
        var splitDate = date.split('/');
        var splitMonth = splitDate[1];
        if(splitMonth === month) {
          if(this.pieDataOriginal[x]) {
            this.pieDataOriginal[x].Amount = parseFloat(this.pieDataOriginal[x].Amount) + parseFloat(this.lossArrayList[x].group[y].Amount);
          } else {
          // this.pieDataOriginal.push({ "Category": this.lossArrayList[x].groupName, "Amount": this.lossArrayList[x].group[y].Amount });
          this.pieDataOriginal[x] = ({ "Category": this.lossArrayList[x].groupName, "Amount": parseFloat(this.lossArrayList[x].group[y].Amount) });
          }
        }
      }
    }
  }
  if(this.pieDataOriginal.length>0) {
    this.pieDataOriginal[this.pieDataOriginal.length] = ({ "Category": "Payroll", "Amount": parseFloat(payroll) });
  }
  //this.pieData[this.pieData.length+1] = ({ "Category": "Payroll", "Amount": parseFloat(array) });
  this.pieData = [];
  this.pieData = this.pieDataOriginal;
    //console.log("piedata=> ");
    //console.log(this.pieData);
    this.getQuarterlySales("1");

  }

  getArray(array,type) {
    if(type==="salesCount") {
      //console.log("salescount");
      //console.log(array);
    } else if(type==="lossArray") {
      this.lossArrayList = array; 
      var el =  (<HTMLInputElement>document.getElementById("ExpenseByCategoryMonth"));
      el.value = this.splitedMonth;
    } else if(type==="totalSalary") {
      this.payroll = array;
      this.getExpenseByCategory(this.splitedMonth,this.payroll);
      
    }
  }

  getQuarterlySales(quarter) {
    this.quarterProfit = [];
    this.quarterLoss = [];
    var i;
    this.quarters = [['Jan','Feb','Mar','Apr'],['May','June','July','Aug'],['Sept','Oct','Nov','Dec']];
    if(quarter==="1") {
      this.salesName = "Q1 Sales";
      this.quarterIndex = this.quarters[0];
      for(i=0;i<4;i++) {
        this.quarterProfit.push(this.totalProfit[String(i)]);
        this.quarterLoss.push(this.totalLoss[String(i)]);
      }
    } else if(quarter==="2") {
      this.salesName = "Q2 Sales";
      this.quarterIndex = this.quarters[1];
      for(i=4;i<8;i++) {
        this.quarterProfit.push(this.totalProfit[String(i)]);
        this.quarterLoss.push(this.totalLoss[String(i)]);
      }
    } else if(quarter==="3") {
      this.salesName = "Q3 Sales";
      this.quarterIndex = this.quarters[2];
      for(i=8;i<12;i++) {
        this.quarterProfit.push(this.totalProfit[String(i)]);
        this.quarterLoss.push(this.totalLoss[String(i)]);
      }
    }
    //this.totalProfit[]
  }

}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/finance-management/finance-dashboard/finance-dashboard.component.ts